/** @format */

import React, { Component } from 'react';
import './styles.scss';
import Logo from 'src/Assets/Images/GE_logo.svg';
import newLogo from 'src/Assets/Images/Branding.svg';
import Support from 'src/Assets/Images/support_icon.svg';
import Account from 'src/Assets/Images/tab_user-circle-solid.svg';
import PrimaryButtonGE from '../PrimaryButtonGE/PrimaryButtonGE';
import { withRouter } from 'react-router-dom';
import { signIn } from 'src/authConfig';
import { MsalContext } from '@azure/msal-react';
import { SFDC_DOMAIN, GE_DOMAIN } from 'src/Config/constants';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import globe from 'src/Assets/Images/global_icon.svg'; 
import { connect } from 'react-redux';
import {
 loadGeoIPCountry, loadGeoIPCountrySuccess, fetchCountry, fetchCountrySuccess, loadUnauthenticatedSupportFaq
} from 'src/Actions/Support/supportActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTranslation } from 'react-i18next';
import { changeUnauthlang } from 'src/Utils';


export class Header extends Component {
  static contextType = MsalContext;
  state = {
    dropdownClicked: false,
    dropdown:false,
  open: false,
  checkIcon: false,
  };
  constructor(props) {
    super(props);

    this.countryRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  accountRef = React.createRef(null);
  
  
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.fetchCountry();
    document.addEventListener("mousedown", this.handleClickOutside);
    let activeLanguage =  localStorage.getItem('activeLanguage');
    this.updateLanguageTranslation(activeLanguage);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  updateLanguageTranslation = (languageName) => {
    const { i18n } = this.props;
    changeUnauthlang(i18n,languageName)
  };

  handleClickOutside(event) {
    if (this.countryRef && !this.countryRef.current.contains(event.target)) {
     this.setState({dropdown: false})
    }
  }

  toggleActiveClass = (e) => {
    this.setState((prevState) => { 
      return { dropdownClicked: !prevState.dropdownClicked };
    });
    this.setState(() => {
      return { open: false };
    });
  };

  toggleClass = (e) => {
    this.setState((prevState) => {
      return { open: !prevState.open };
    });
    this.setState((prevState) => {
      return { dropdown: !prevState.dropdown };
    });
  };


  handleSupportClick = () => {
    this.props.history.push('/support');
    this.setState(() => {
      return { open: false };
    });
  };

  handleHomeRedirect = () => {
    this.props.history.push('/login');
    window.location.reload();
    
  };

  setlocalCountry=(countryCode, languageCode, languageName, e) =>{
    localStorage.setItem('activeCountry', countryCode + languageCode);
    localStorage.setItem('activeLanguageCountry', languageName +"/"+ countryCode);
    localStorage.setItem('activeLanguage', languageName);
    this.updateLanguageTranslation(languageName);
    this.props.loadUnauthenticatedSupportFaq();
    this.setState((prevState) => {
      return { dropdown: !prevState.dropdown };
    });
    this.setState((prevState) => {
      return { open: !prevState.open };
    });
  } 
  renderCountries = () =>{
    let responseCountries = this.props.support.countryList;
    let currentCountry = localStorage.getItem('activeCountry');
    
   return (
     <>
        <ul className="list__country-dropdown">
        <FontAwesomeIcon icon="fa-solid fa-check" />
         {( responseCountries &&
          responseCountries.map((ob, idx) => 
          ((ob.countryCode + ob.languageCode) == currentCountry? (  
            <li className="li__country-dropdown button-li"  onClick={(e) => this.setlocalCountry(ob.countryCode, ob.languageCode, ob.languageName, e)} style={{ backgroundColor: '#02536c' ,border:'0px'}}>
          
          
            <li className="sso-text__li" style={{backgroundColor: '#02536c',paddingLeft: '15px'}}> {ob.countryName}</li>
        </li>):
            (
            <li className="li__country-dropdown button-li"  onClick={(e) => this.setlocalCountry(ob.countryCode, ob.languageCode, ob.languageName, e)}>
              
              <li className="sso-text__li"  style = {{ paddingLeft: '15px' }} >  {ob.countryName}</li>
                 
        </li>
    )))
  )}  </ul>

  </>
    )
  }
  render() {
    const { t } = this.props;
    const { dropdownClicked, dropdown, open } = this.state;
    const loginType = localStorage.getItem('loginType');
    let activeCountry =  localStorage.getItem('activeCountry');
    let displayCountry = "";
    let responseCountries = this.props.support.countryList;
    responseCountries.forEach((item)=>{
      if((item.countryCode + item.languageCode) == activeCountry){
        displayCountry = item.countryName
      }
    })
    return (
      <div className="unauth-header-wrapper">
        <section
          className="logo-text-container"
          onClick={this.handleHomeRedirect}
        >
          <img src={newLogo} alt="logo" />
          <div className='logo-line'></div>
          <span className="logo-text">{t('digitalExpert')}</span>
        </section>
        <section className="support-account-container">
          
          <span className='country-picker' ref={this.countryRef}> 
          <span
            className={
              !dropdown
                ? 'country-icon-text-wrapper hover-hand'
                : 'country-icon-text-wrapper hover-hand active-toggle-button'
            }
            onClick={this.toggleClass}
            
            >
            <img className="country-logo" src={globe} />
            <span className="country-texts-container">
              <div className="country-text" >{displayCountry}</div>
             
          
            </span>
            
            <FontAwesomeIcon style = {{ marginLeft: '4px' }} icon={open ? 'angle-up' : 'angle-down'} />
            <div className={dropdown ? 'overlay-clicked' : 'overlay'} />
             </span>
             <div
              className={
                !dropdown ? 'country-dropdown' : 'country-dropdown-clicked'
              }
              >
            {this.renderCountries()}
            </div>
          </span>
          <span className="support-data-container">
            <span className="support-text" onClick={this.handleSupportClick}>
              {t('support')}
            </span>
            <img
              className="support-logo"
              src={Support}
              onClick={this.handleSupportClick}
            />
          </span>
          <span
            ref={this.accountRef}
            className={
              !dropdownClicked
                ? 'account-icon-text-wrapper hover-hand'
                : 'account-icon-text-wrapper hover-hand active-toggle-button'
            }
            onClick={this.toggleActiveClass}
          >
            <img className="account-logo" src={Account} />
            <span className="account-texts-container">
              <span className="account-text">{t('account')}</span>
              <span className="signin-text">{t('signIn')}</span>
            </span>
            <div
              className={
                !dropdownClicked ? 'signin-dropdown' : 'signin-dropdown-clicked'
              }
            >
              <ul className="list__signin-dropdown">
                <li className="li__signin-dropdown button-li">
                  <PrimaryButtonGE
                    text={t('signin_button')}
                    onClick={() => {
                      const digitalData = {
                        user: {
                          profile: {
                            profileInfo: {
                              loginStatus: 'logged in',
                            },
                          },
                          userType: '',
                        },
                      };
                      AnalyticsService.updateDigitalData(digitalData);
                      AnalyticsService.trackEvent('signin_start');
                      signIn(SFDC_DOMAIN);
                    }}
                  />
                </li>
                <li
                  className="li__signin-dropdown logo-sso-li"
                  onClick={() => {
                    const digitalData = {
                      user: {
                        profile: {
                          profileInfo: {
                            loginStatus: 'logged in',
                            profileID: '',
                          },
                        },
                        userType: loginType,
                      },
                    };
                    AnalyticsService.updateDigitalData(digitalData);
                    AnalyticsService.trackEvent('signin_start');
                    signIn(GE_DOMAIN);
                  }}
                >
                  <img src={Logo} id="li__dropdown__logo" alt="logo" />
                  <span className="sso-text__li">{t('sso')}</span>
                </li>
              </ul>
            </div>
            <div className={dropdownClicked ? 'overlay-clicked' : 'overlay'} />
          </span>
        </section>
      </div>
    );
  }
}


const mapStateToProps = ({ support }) => ({
  support
});

export const mapDispatchToProps = (dispatch) => ({
    
  loadGeoIPCountry: () => dispatch(loadGeoIPCountry()),
  loadGeoIPCountrySuccess: (list) => dispatch(loadGeoIPCountrySuccess(list)),
  fetchCountry: () => dispatch(fetchCountry()),
  fetchCountrySuccess: (list) => dispatch(fetchCountrySuccess(list)),
  loadUnauthenticatedSupportFaq: () => dispatch(loadUnauthenticatedSupportFaq()),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Header)));

